var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 349.992,
  height: 333.327,
  viewBox: "0 0 349.992 333.327"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.995h262.494V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .01 333.327h349.982V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P3_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.327)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M195.727 52.114c0-21.96-19.977-27.518-35.32-27.518-8.07 0-17.33 1.06-24.205 3.042l1.056 15.745c6.35-2.516 13.23-4.234 20.5-4.234 7.676 0 19.45 3.703 19.45 13.09 0 10.85-8.596 14.425-20.37 14.425h-8.998v14.55h8.467c12.437 0 20.498 4.097 20.498 12.167 0 9.26-7.53 12.175-15.868 12.175-7.28 0-14.284-1.723-20.77-4.898l-1.06 14.816c7.412 2.908 16.274 4.63 25.796 4.63 11.38 0 30.428-3.97 30.428-23.675 0-12.57-7.805-18.524-17.2-22.094v-.27c11.78-1.582 17.598-10.71 17.598-21.953M94.025 157.17H84.37v41.958h9.655c14.183 0 26.194-5.513 26.194-21.472 0-15.954-12.41-20.485-26.196-20.485m54.952 22.063c0 32.9-27.38 41.57-57.322 41.57H56.79v-137.5h27.58V135.5h11.615c29.554 0 52.992 11.624 52.992 43.732"
}))));
export default SvgParkingP3;